import { IconButton } from 'component/Button/IconButton'
import { Modal } from 'component/Modal'
import { Qr } from 'component/Qr'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'

export const LookyQr = observer(() => {
  const inference = store.fullscreen?.inferences?.item ?? store.carousel?.carousel.item
  const url = inference?.url || ''
  const open = store.carousel?.looky
  const link = store.getLookyShareLink(url)

  const onClose = useLatestCallback(async () => {
    store.carousel.looky = false
  })

  if (!inference || !open) return null

  return <Modal>
    <Space opposite>
      <Typo size={16}>
        {i18n('ShareInLooky')}
      </Typo>
      <IconButton action={onClose}>
        <Icon size={20} name="close" />
      </IconButton>
    </Space>
    <Space center>
      <Qr link={link} size={240} />
    </Space>
    <Space center>
      <Typo size={13} center>
        {i18n('OpenLinkInLookyAppOnMobile')}
      </Typo>
    </Space>
  </Modal>
})
